@if (AIContextTemplates.length > 0) {
  <div class="d-flex align-items-center bg-[#f5f8ff] rounded-[12px]">
    <button #templateButton mat-button (click)="openTemplateListOverlay(templateButton)" class="template-picker-button">
      <b>{{ 'Templates.Template' | translate }} :</b>
      <span class="template-name">{{ getSelectedTemplate()?.name || ('Global.None' | translate) | translate }}</span>
    </button>
  </div>
}

@if (AIContextTemplates.length == 0 && initDone) {
  <div>
    <button mat-raised-button color="primary" [disabled]="loading" (click)="openCreateTemplateDialog()">
      <mat-icon>add</mat-icon>
      <span>{{ 'Templates.CreateButton' | translate }}</span>
    </button>
  </div>
}
